import { render, staticRenderFns } from "./other-expense-list.html?vue&type=template&id=4162fdbe&scoped=true&"
import script from "./other-expense-list.js?vue&type=script&lang=js&"
export * from "./other-expense-list.js?vue&type=script&lang=js&"
import style0 from "./OtherExpenseList.vue?vue&type=style&index=0&id=4162fdbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4162fdbe",
  null
  
)

component.options.__file = "OtherExpenseList.vue"
export default component.exports